import React from 'react';
import AbsoluteFooter from '../../components/Footer/AbsoluteFooter';
import { useStateContext } from '../../context/ContextProvider';

const Thankyou = ({
    language
}) => {

    return (
        <div className="secondary-bg">
            <div className="w-full h-[100vh] flex justify-center items-center">
                <div className="text-xl text-center my-5 p-5">
                    <span className="text-white">
                        {language === "ar"
                            ? "شكرا لتواصلك معنا."
                            : "Thank you for reaching out to us."
                        }&nbsp;
                    </span>
                    <br />
                    {language === "ar"
                        ? "سيتواصل معك مستشارنا المخصص قريبًا لتلبية احتياجاتك."
                        : "Our dedicated consultant will be in contact with you shortly to address your needs."
                    }&nbsp;
                </div>
                <div className="fixed w-full top-0 left-0">
                    <div className="flex justify-center p-5">
                        <img src="/assets/images/logo/dodeal-properties-white.png" alt="DoDeal Properties" className="w-[100px]" />
                    </div>
                </div>
                <AbsoluteFooter />
            </div>
        </div>
    );
}

export default Thankyou;
